exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-index-tsx": () => import("./../../../src/pages/index/index.tsx" /* webpackChunkName: "component---src-pages-index-index-tsx" */)
}

